import type { FaireThemeEntity } from "../../entity_types/theme";

export const the_faithful_mother_and_mini: FaireThemeEntity = {
  token: "the-faithful-mother-and-mini",
  type: "theme",
  name: "The Faithful Mother & Mini",
  description: "A curated collection of faith-forward apparel and gifts that celebrate motherhood and spiritual growth for both parents and children.",
  teaser: "Faith-forward apparel for mamas and minis -- your bestselling category, expanded.",
  detail: "Your frequent orders of Jesus Loves You youth apparel and faith-based hoodies show clear demand. This theme builds on that with coordinating mama-and-mini pieces, from Child of God pouches to He Still Does Miracles vintage caps.",
  bgColor: "#F0D4C4",
  tileBgColor: "#7b5a6e",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_9pxyxt9fdp",
    "p_jz6bubavx3",
    "p_eg4rqajj42",
    "p_uqfjc4mrxe",
    "p_snqggxjskf",
    "p_rrjxbj4kjq",
    "p_z2kahvb9he",
    "p_zw6ga6sqfc",
    "p_xpzb46thab",
    "p_tp8vrwqcu2",
    "p_d9cqnsd3re",
    "p_whaznkuuf3",
    "p_tzuyzvvefa",
    "p_mmcbhxghnx",
    "p_asf6zq38pw",
    "p_s46e7wm4wv",
    "p_nsz76f854y",
    "p_nc5ryb94n2",
    "p_f7wx7hpyct",
    "p_225q3pgfxf",
    "p_x6kh4xrxe7",
    "p_e8p9vv37k7",
    "p_ekkpeqxzm5",
    "p_bqsbnl15ng",
    "p_4kyn7eah28",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
